/**
 * @generated SignedSource<<2e353f4a49b60d79d2991676e2ae9985>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LabelSidebar_label$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EntitySidebar_entity">;
  readonly " $fragmentType": "LabelSidebar_label";
};
export type LabelSidebar_label$key = {
  readonly " $data"?: LabelSidebar_label$data;
  readonly " $fragmentSpreads": FragmentRefs<"LabelSidebar_label">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LabelSidebar_label",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntitySidebar_entity"
    }
  ],
  "type": "Label",
  "abstractKey": null
};

(node as any).hash = "85030f579f83c42218926ad5f475f8ee";

export default node;
